import { AuthPageStyling } from "src/context/types"
import usePageStyling from "src/hooks/usePageStyling"

const useGridPageStyling = () => {
  const style: AuthPageStyling = usePageStyling("authPageStyling")

  // We are going to get this value from the server.
  return {
    backgroundColor: "black",
    panelBackgroundColor: "rgba(34, 34, 34, 0.9)",
    panelTextColor: "white",
    panelBorderColor: "rgba(34, 34, 34, 0.9)",
    panelMouseoverBackgroundColor: style?.authPageButtonBackgroundColor,
    panelMouseoverTextColor: style?.authPageButtonTextColor,
    panelMouseoverBorderColor: style?.authPageButtonBackgroundColor,
    buttonBackground: style?.authPageButtonBackgroundColor,
    buttonText: style?.authPageButtonTextColor,
    buttonBackgroundHover: "#dfdd02",
    buttonTextHover: style?.authPageButtonMouseoverTextColor,
  }
}

export default useGridPageStyling
